import { Grid, Typography } from "@mui/material";
import React from "react";

const Page3ForCarousal = () => {
  const faqList = [
    {
      ques: "Lower the total cost of ownership :",
      ans: "The reason that pirate parts have a market is that they can offer a lower upfront cost. However, by choosing to buy genuine parts, you can reduce the total cost of ownership and save yourself money in the long term.",
    },
    {
      ques: "Designed for your equipment :",
      ans: "Genuine parts are guaranteed to fit into your existing machines as intended, which will allow processes to continue as intended.",
    },
    {
      ques: "Automatically revised and updated :",
      ans: "Simpson is in ongoing research and development regarding our Engines and parts, meaning that we are continually revise our parts to make them more effective.",
    },
    {
      ques: "Compliance with warranties",
      ans: "When you buy Genuine Parts from, you are likely to be covered by a warranty. This includes warranty on the parts attached to that equipment, meaning that if something goes wrong, you will be able to get a replacement or repair from the manufacturer.",
    },
    {
      ques: " Increased safety",
      ans: "One of the key reasons for always choosing genuine over pirate parts is the reduced risk it offers to your machines.",
    },
    {
      ques: "Access to OEM equipment experts",
      ans: "Beyond the quality of the parts, choosing genuine equipment and components will allow you benefit from the expertise of the manufacturers who made them. ",
    },
    {
      ques: " Reliability",
      ans: "Minimize downtime and maintain top performance, comfort and convenience by choosing genuine Simpson parts",
    },
  ];
  return (
    <div className="carousal-con">
      <div className="faq-con">
        <Grid container>
          <Grid item md={2}>
            <p className="parts-heading p-margin-0">Why GENUINE SPARES?</p>
          </Grid>
          <Grid item md={10}>
            <div>
              <p className="parts-desc p-margin-0">
                To ensure the best results on Simpson engine and to safeguard
                the warranty, fit, only genuine PARTS.
              </p>
            </div>
            <Typography
              variant="body1"
              sx={{
                marginTop: 3,
                borderTop: "1px solid #D8D8D8",
                borderBottom: "1px solid #D8D8D8",
                p: "0.5rem 0px",
                fontWeight: 600,
                marginBottom: 1,
              }}
              className="primary-text"
            >
              ADVANTAGES OF GENUINE SPARES :
            </Typography>
            <div className="list-con">
              {faqList?.map((ele, index) => {
                return (
                  <div>
                    <p className="faq-points primary-text">
                      <span className="points-count">{index + 1}. </span>{" "}
                      {ele.ques}
                    </p>
                    <Typography variant="body2">{ele.ans}</Typography>
                  </div>
                );
              })}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Page3ForCarousal;
